// @flow
import type {Node} from 'react'
import React from 'react'

import type {PickAlert, UpdateCallback, DeleteCallback} from 'components/proposals/types'
import CreateLinkedRoleEditor from './CreateLinkedRoleEditor'
import UpdateLinkedRoleEditor from './UpdateLinkedRoleEditor'
import type {
  Accountability,
  AvailableRoles,
  Circle,
  Domain,
  LinkedRole,
  OriginalRole,
  Organization,
} from '../types'

type Props = $ReadOnly<{
  accountabilities: Accountability[],
  availableRoles: AvailableRoles[],
  changeKey: string,
  circle: Circle,
  domains: Domain[],
  organization: Organization,
  destroy: boolean,
  isReadonly: boolean,
  linkedRole: ?LinkedRole,
  originalRole: ?OriginalRole,
  onChange: UpdateCallback,
  onDelete: DeleteCallback,
  pickAlert: PickAlert,
}>

function Editor({
  accountabilities,
  availableRoles,
  changeKey,
  circle,
  domains,
  organization,
  destroy,
  isReadonly,
  linkedRole,
  originalRole,
  onChange,
  onDelete,
  pickAlert,
}: Props): Node {
  if (linkedRole) {
    return (
      <UpdateLinkedRoleEditor
        accountabilities={accountabilities}
        changeKey={changeKey}
        circle={circle}
        domains={domains}
        organization={organization}
        destroy={destroy}
        isReadonly={isReadonly}
        linkedRole={linkedRole}
        onChange={onChange}
        onDelete={onDelete}
        pickAlert={pickAlert}
      />
    )
  }

  return (
    <CreateLinkedRoleEditor
      availableRoles={availableRoles}
      circle={circle}
      organization={organization}
      isReadonly={isReadonly}
      originalRole={originalRole}
      onChange={onChange}
      pickAlert={pickAlert}
    />
  )
}

export default Editor
